import { render, staticRenderFns } from "./ForgotPasswordToken.vue?vue&type=template&id=4b0c052e&scoped=true&"
import script from "./ForgotPasswordToken.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c052e",
  null
  
)

export default component.exports